<template>
  <div class="container sv029">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>セブン銀行スマホATMでご返済</HeadingOne>

    <p>
      au PAY
      スマートローンアプリをインストールすると、原則24時間365日全国のセブン銀行ATMでカードレスでご返済が可能です。
    </p>

    <ListGroup class="-note">
      <ListItem class="-note"
        >ご利用にはau PAY スマートローンアプリが必要となります。</ListItem
      >
      <ListItem class="-note"
        >システムメンテナンスなどでご利用いただけない場合がございます。</ListItem
      >
    </ListGroup>
    <ListGroup class="-link _mb-md-60 _mb-sm-4 0">
      <ListItem class="-link" router-name="sv059"
        >会員さま専用サイト・専用アプリの使い方について</ListItem
      >
    </ListGroup>

    <section>
      <HeadingTwo>セブン銀行スマホATMでのご返済方法</HeadingTwo>
      <StepList type="sv" class="_mb-md-60 _mb-sm-20 -green">
        <StepItem
          number="1"
          title="au PAY スマートローンアプリを起動"
          src="sv/sv029/img01.jpg"
        >
          <p>スマートフォンから「au PAY スマートローンアプリ」を起動します。</p>
        </StepItem>
        <StepItem
          number="2"
          title="「セブン銀行スマホATMでご返済」を選択"
          src="sv/sv029/img02.jpg"
        >
          <p>
            アプリホーム画面の「セブン銀行スマホATMでご返済」を選択すると、QRコード読み取り画面が表示されます。画面を表示したまま、以降はATM画面で操作を続けてください。
          </p>
        </StepItem>
        <StepItem
          number="3"
          title="ATM操作：「引出し・預入れ クレジット取引など」を選択"
          src="sv/sv029/img03.png"
        >
          <p>セブン銀行ATM画面より「引出し・預入れ クレジット取引など」を選択します。</p>
        </StepItem>
        <StepItem
          number="4"
          title="ATM操作：「スマートフォン」を選択"
          src="sv/sv029/img04.png"
        >
          <p>セブン銀行ATM画面より「スマートフォン」を選択</p>
        </StepItem>
        <StepItem number="5" title="QRコード読み取り" src="sv/sv029/img05.png">
          <p>セブン銀行ATM画面に表示されるQRコードをアプリで読み取ります。</p>
          <ListGroup class="-note">
            <ListItem class="-note"
              >au PAY
              スマートローンアプリで読み取ってください。そのほかのカメラアプリで読み取ってもお手続きできません。</ListItem
            >
          </ListGroup>
        </StepItem>
        <StepItem
          number="6"
          title="ATM操作：企業番号入力"
          src="sv/sv029/img06.png"
        >
          <p>アプリに表示される企業番号をATMへ入力します。</p>
        </StepItem>
        <StepItem
          number="7"
          title="ATMへご入金"
          src="sv/sv029/img07.png"
          class="-last"
        >
          <p>ATMへご入金してください。</p>
        </StepItem>
        <StepFooter>
          <template #heading>お手続き完了</template>
          <template #text>
            <p class="_mt-15">
              ATMでの操作が完了すると、ご返済完了となります。
            </p>
            <p>お取引終了後はアプリを終了してください。</p>
          </template>
        </StepFooter>
      </StepList>
      <ListGroup class="-note">
        <ListItem class="-note"
          >ＡＴＭ手数料はお客さまのご負担となります。お借り入れ、ご返済の取引金額１万円以下の場合は110円（税込）、１万円を超える場合は220円（税込）。</ListItem
        >
        <ListItem class="-note"
          >ご返済時に発生するＡＴＭ手数料は、ご返済とあわせてご精算いただきます。</ListItem
        >
      </ListGroup>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>ご返済時期について</HeadingTwo>
      <p class="-bold">
        毎月のご返済日（26日*）の20日前より、当月のご返済が可能です。
      </p>
      <div class="_mb-md-60 _mb-sm-30">
        <small>* 金融機関休業日の場合は、翌営業日となります。</small>
      </div>

      <div class="_textcenter _mb-10">
        <img
          src="@/assets/images/sv/sv029/img09.png"
          class="img-fluid -spnone"
          alt=""
        />
        <img
          src="@/assets/images/sv/sv029/sp/img09.png"
          class="img-fluid -pcnone"
          alt=""
        />
      </div>

      <ListGroup class="-note">
        <ListItem class="-note"
          >当該期間にご返済いただいた場合、次回の期日返済は次月の26日となります。</ListItem
        >
      </ListGroup>
    </section>

    <template v-if="!isWebView()">
      <section class="_mb-md-120 _mb-sm-60">
        <HeadingTwo>アプリダウンロード</HeadingTwo>
        <p>
          iOS、Androidのスマートフォンでアプリをご利用いただけます（無料）。
        </p>
        <AppDownlord payback="true"></AppDownlord>
      </section>
    </template>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
// import TabHeader from '@/components/tabs/TabHeader';
// import TabItem from '@/components/tabs/TabItem';
// import TabFilled from '@/components/tabs/TabFilled';
import StepList from "@/components/steps/StepList";
import StepItem from "@/components/steps/StepItem";
import StepFooter from "@/components/steps/StepFooter";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
// import BtnMain from '@/components/button/BtnMain';
// import BtngroupSingle from '@/components/button/BtngroupSingle';
// import TableBox from '@/components/tables/TableBox';
// import TableBody from '@/components/tables/TableBody';
// import TableRow from '@/components/tables/TableRow';
// import TableHeader from '@/components/tables/TableHeader';
// import TableData from '@/components/tables/TableData';
import CvBox from "@/components/box/CvBox";
// import CardBox from '@/components/card/CardBox';
// import CardHeader from '@/components/card/CardHeader';
// import CardBody from '@/components/card/CardBody';
import ContactBox from "@/components/box/ContactBox";
import AppDownlord from "@/components/others/AppDownlord";
// import BtnText from '@/components/button/BtnText';
import { isWebView } from "@/utils/UserAgent";

export default {
  name: "Sv029",
  components: {
    BreadcrumbGroup,
    // BtnText,
    AppDownlord,
    ContactBox,
    // CardBody,
    // CardHeader,
    // CardBox,
    CvBox,
    // TableData,
    // TableHeader,
    // TableRow,
    // TableBody,
    // TableBox,
    // BtngroupSingle,
    // BtnMain,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    StepList,
    // TabFilled,
    // TabItem,
    // TabHeader,
    HeadingOne,
    HeadingTwo,
  },
  setup() {
    setMeta({
      title: "セブン銀行スマホATMでご返済｜ご返済方法",
      description:
        "セブン銀行スマホATMを利用したご返済方法をご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,アプリ,スマホアプリ",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "ご返済について",
          routerName: "sv047",
        },
        {
          text: "セブン銀行スマホATMでご返済",
          active: true,
        },
      ],
    };
  },
  methods: {
    isWebView() {
      return isWebView();
    },
  },
};
</script>

<style scoped></style>
